import React from 'react';

import FieldSelect from '../common/FieldSelect';
import Const from '../../util/Constants';
import TowerAPI from '../../api/TowerAPI';
import PropertyAPI from '../../api/PropertyAPI';
import RoomAPI from '../../api/RoomAPI';
import FloorRiseAPI from '../../api/FloorRiseAPI';
import './SalesOrder.css';

class SalesOrderUpdateProject extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { changed: false, roomsData: [] };
  }

  onChange = (field, value) => {
    this.props.onChange(field, value);
    if(field === 'project' && value) {
      if(this.props.IsInventory) {
        TowerAPI.getInnerList(Const.Project, value, this.onTowerReceived);
      }
    } 
    
    if(field === 'tower' && value) {
      this.setState({ changed: !this.state.changed });
      RoomAPI.getInnerList(Const.Tower, value, this.onRoomReceived);
    }

    if(field === 'room' && value) {
      setTimeout(() => {
        this.calculateFloorRiseForRoom(value);
      }, 100);

      const room = this.props.fields.room.options.find(item => item.value === value || item.id === value);
      if(room) {
        PropertyAPI.get(room.property, data => this.props.onChange('property', data.id, data));
      }
    }
  }

  calculateFloorRiseForRoom = (roomId) => {
    const { sale, onChange } = this.props;
    const { roomsData } = this.state; 

    if (!sale.project || !sale.tower || !roomId) return;
    
    if (!roomsData || roomsData.length === 0) {
      const roomOption = this.props.fields.room.options?.find(opt => opt.value === roomId);
      if (roomOption && roomOption.floor_no) {
        this.getFloorRiseWithFloor(roomOption.floor_no, sale, onChange);
        return;
      }
      return;
    }

    const selectedRoom = roomsData.find(room => room.id == roomId);
    if (!selectedRoom) {
      const roomFromOptions = this.props.fields.room.options?.find(opt => opt.value == roomId);
      if (roomFromOptions && roomFromOptions.originalData) {
        this.getFloorRiseWithFloor(roomFromOptions.originalData.floor_no, sale, onChange);
      }
      return;
    }
  
    const floorNo = selectedRoom.floor_no;
    this.getFloorRiseWithFloor(floorNo, sale, onChange);
  }

  getFloorRiseWithFloor = (floorNo, sale, onChange) => {
    FloorRiseAPI.getList(
      sale.project,
      sale.tower,
      (floorRiseResponse) => {
        this.processFloorRiseResponse(floorRiseResponse, floorNo, sale, onChange);
      },
      (error) => {
        onChange('floor_rise_cal', 0);
      },
      () => {
        onChange('floor_rise_cal', 0);
      }
    );
  }

  processFloorRiseResponse = (floorRiseResponse, floorNo, sale, onChange) => {
    let calculatedValue = 0;
    
    if (floorRiseResponse && floorRiseResponse.length > 0) {

      const applicableRise = floorRiseResponse.find(rise => {
        return parseInt(floorNo) >= parseInt(rise.from_floor) && 
               parseInt(floorNo) <= parseInt(rise.to_floor);
      });
      
      if (applicableRise) {
        const type = parseInt(applicableRise.type);
        const fromFloor = parseInt(applicableRise.from_floor);
        const toFloor = parseInt(applicableRise.to_floor);
        const value = parseFloat(applicableRise.value);
        const currentFloor = parseInt(floorNo);
        
        // Calculate based on type
        switch(type) {
          case 1:
            calculatedValue = value;
            break;
            
          case 2:
            calculatedValue = value;
            break;
            
          case 3:
            const floorDifference = currentFloor - fromFloor + 1;
            calculatedValue = value * floorDifference;
            break;
            
          default:
            calculatedValue = 0;
        }

      }
    }
    
    onChange('floor_rise_cal', calculatedValue);
  }

  onTowerReceived = res => {
    const options = res.data.map(tower => {
      return {label: tower.tower_name, value: tower.id, status: 4 };
    });
    this.props.fields.tower.options = options;
    this.setState({ changed: !this.state.changed });
  }

  onRoomReceived = res => {
    this.setState({ 
      roomsData: res.data 
    }, () => {
      this.props.fields.room.options = res.data
        .filter(room => room.room_status === 1)
        .map(room => {
          return {
            label: room.room_name, 
            value: room.id, 
            property: room.property, 
            status: 4,
            originalData: room
          };
        });
      
      this.props.onChangeRooms(this.props.fields.room.options);
      this.setState({changed: !this.state.changed });
    });
  }

  render() {
    return (
      <>
        <FieldSelect key="project" id="project" field={this.props.fields.project}
          value={this.props.sale.project} onValueChange={this.onChange}
          inValid={this.props.inValid} />

        { this.props.sale.project ?
          <FieldSelect key="tower" id="tower" field={this.props.fields.tower}
            value={this.props.sale.tower} onValueChange={this.onChange}
            inValid={this.props.inValid} changed={this.state.changed} /> : null
        }

        { this.props.sale.tower ?
          <FieldSelect key="room" id="room" field={this.props.fields.room}
            value={this.props.sale.room} onValueChange={this.onChange}
            inValid={this.props.inValid} /> : null
        }
      </>
    );
  }
}
export default SalesOrderUpdateProject;
